








import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'ContentBanner'
})
export default class extends Vue {}
